<template>
    <div style="padding:0;">
        <van-nav-bar title="返回" left-arrow @click-left="$goBack()"/>
        <img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NXahpvG.png" width="100%" style="height:23vh;"/>

        <van-tabs>
            <van-tab key="1" title="福利">
                <div style="height:69vh; overflow-y:scroll;">
                    <div style="margin:1rem; font-size:1.2rem; text-align:center;">
                        领码后7日内若未产生数据，需重新领取二维码/海报
                    </div>
                    <div class="task" v-for="task in showTaskList" :key="task.id"
                         v-if="showTaskList&&showTaskList.length!=0">
                        <van-row>
                            <van-col span="18">
                                <van-row>
                                    <div v-html="task.showName">{{task.showName}}</div>
                                </van-row>
                                <van-row style="margin:0.5rem 0;font-size:1.1rem;color:#8b8b8b;">
                                    奖励：{{task.price}}
                                </van-row>
                                <van-row style="margin:0.5rem 0;font-size:1.1rem;color:#8b8b8b;">
                                    {{task.settleRule}}
                                </van-row>
                                <van-row style="font-size:1.1rem;color:#8b8b8b;">
                                    {{task.ruleDesc}}
                                </van-row>
                            </van-col>
                            <van-col span="6" style="text-align:right;margin-top:2.6rem;">
                                <van-button round size="small" @click="queryTaskShare(task)" style="width:6rem;">
                                    点击领码
                                </van-button>
                            </van-col>
                        </van-row>
                    </div>
                </div>
            </van-tab>
            <van-tab key="2" title="数据">
                <div class="buttom">
                    <van-row>
                        <van-col span="18">
                            <strong>完成明细</strong>
                        </van-col>
                        <van-col span="6">
                            <select v-model="month4selected" @change="handleMonth4Change">
                                <option v-for="(value,key) in month4SelecteMap" :key="key" :value="key">{{value}}
                                </option>
                            </select>
                        </van-col>
                    </van-row>
                    <van-row>
                        <van-tabs v-model="jobActive" color="#ee9900" title-active-color="#ee9900" @change="jobChange">
                            <van-tab v-for="item in showTaskList" :title="item.name" :key="item.id">
                                <div class="table-box" v-if="logDetail.page.rows&&logDetail.page.rows.length>0">
                                    <div style="margin: 0.2rem 0 0.5rem 0; color: #7d7e80;">
                                        {{item.name}}：
                                    </div>
                                    <table>
                                        <tr>
                                            <th>日期</th>
                                            <th>裂变id</th>
                                            <th>结算状态</th>
                                            <th v-for="(name,key1) in logDetail.detailMap" :key="key1">
                                                {{name}}
                                            </th>
                                        </tr>
                                        <tr v-for="(row,index) in logDetail.page.rows" :key="index"
                                            @click="upDetailShow(row.jobId,row.upStreamNo)">
                                            <td>{{row.settleDate | parseTime('{m}-{d}')}}</td>
                                            <td>{{row.upPid}}</td>
                                            <td>{{statusMap[row.status]}}</td>
                                            <td v-for="(name,key1) in logDetail.detailMap" :key="key1">
                                                {{row.upstreamFieldMap[key1]}}
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="noData" v-else>
                                    <div><i class="icon-task icon-ku"></i></div>
                                    <div>暂无数据</div>
                                </div>

                            </van-tab>
                            <van-pagination v-model="queryLog.page" :total-items="logDetail.page.total"
                                            :items-per-page="queryLog.limit" @change="handlePageChange" mode="simple"/>
                        </van-tabs>
                    </van-row>

                    <van-row>客服微信号：youtui005</van-row>
                </div>
            </van-tab>
        </van-tabs>

        <van-dialog v-model="dialogVisible" confirmButtonText="关闭" @confirm="initPainting">
            <div style="text-align:center;">
                <div class="title">{{jobInfo.name}}</div>
                <div v-if="!showPoster" class="qrCode">
                    <vue-qr :margin="0" :text="jobInfo.jobQrCode" :logoScale="0.25"
                            v-if="jobInfo.jobQrCode" :size="185" :callback="qrCallback"></vue-qr>
                </div>
                <div v-if="!showPoster" class="title">{{jobInfo.ruleDesc}}</div>

                <div v-if="showPoster">
                    <img :src="shareImgSrc" width="100%"/>
                    <vue-canvas-poster :widthPixels="565" :painting="painting" @success="success" @fail="fail">
                    </vue-canvas-poster>
                </div>

                <van-button v-if="jobInfo.jobQrCode && jobInfo.jobExInfo.posterUrl" round type="danger"
                            @click="showPoster = !showPoster">
                    点击切换{{showPoster ? '二维码' : '海报'}}
                </van-button>
                <div style="margin:0.5rem;">长按图片保存至本地</div>
            </div>
        </van-dialog>
    </div>
</template>

<script>
    import tuandui from '@/assets/images/tuandui.png';
    import vueQr from 'vue-qr'
    import mainAPI from '@/api/main';
    import constantAPI from '@/api/constant';
    import wxShare from '@/utils/wxShareService';
    import pvuvAPI from '@/api/pvuv';
    import countAPI from '@/api/count'

    export default {
        components: {
            vueQr
        },
        data() {
            return {
                tuandui: tuandui,
                query: {
                    traderId: this.$route.query.traderId,
                    mid: this.$route.query.mid,
                },
                showTaskList: [
                    {
                        id: 103,
                        showName: '淘宝特价版<span style="font-size:2rem;font-weight:bold;">5元</span>购物红包',
                        name: '淘宝特价版5元购物红包',
                        ruleDesc: '使用淘宝扫码-下载特价版-打开后淘宝登陆-5元券-下单',
                        price: 7,
                        settleRule: '预估数据：T+1 结算数据：T+7',
                    },
                    {
                        id: 90,
                        showName: '京东金融新客<span style="font-size:2rem;font-weight:bold;">8元</span>话费红包',
                        name: '京东金融新客8元话费红包',
                        ruleDesc: '扫码-输入手机号码-下载金融APP-领取话费红包-绑卡使用红包',
                        price: 7,
                        settleRule: '结算数据：T+1',
                    },
                    {
                        id: 93,
                        showName: '快手新用户<span style="font-size:2rem;font-weight:bold;">1元</span>购',
                        name: '快手新用户1元购',
                        ruleDesc: '下载-同意并继续-关闭红包-微信登录-扫码-点击确认绑定-下单支付(山西、辽宁地区做单不结算)',
                        price: 11,
                        settleRule: '预估数据：T+2 结算数据：T+2',
                    },
                    // {
                    //     id: 73,
                    //     showName: '苏宁新用户<span style="font-size:2rem;font-weight:bold;">1元</span>购好物',
                    //     name: '苏宁新用户1元购好物',
                    //     ruleDesc: '下载苏宁易购-扫码复制口令-打开App点击前往查看-领券-下单-拼团成功',
                    //     price: 6.5,
                    //     settleRule: '预估数据：T+1 结算数据：T+5',
                    // },
                    {
                        id: 22,
                        showName: '京东新用户<span style="font-size:2rem;font-weight:bold;">8元</span>优惠券',
                        name: '京东新用户8元优惠券',
                        ruleDesc: '扫码注册-领取8元优惠券-下单',
                        price: 8,
                        settleRule: '结算数据：T+5',
                    },
                    {
                        id: 108,
                        showName: '读微信文章赚钱',
                        name: '读微信文章赚钱',
                        ruleDesc: '扫码-阅读至少30秒且读完整篇文章-点击后退可读下一篇',
                        price: '最低0.045/次',
                        settleRule: '周结',
                    },
                    {
                        id: 45,
                        showName: '<span style="font-size:2rem;font-weight:bold;">30G</span>定向流量免费领',
                        name: '30G定向流量免费领',
                        ruleDesc: '扫码-填写信息-快递协助激活',
                        price: 33,
                        settleRule: '结算数据：激活后T+1',
                    },
                    {
                        id: 46,
                        showName: '淘宝新客<span style="font-size:2rem;font-weight:bold;">9.9元</span>商品免费送',
                        name: '淘宝新客9.9元商品免费送',
                        ruleDesc: '下载APP-扫码-领券-0元下单',
                        price: 22,
                        settleRule: '预估数据：T+1 结算数据：T+3',
                    },
                    // {
                    //     id: 98,
                    //     showName: '支付宝新客<span style="font-size:2rem;font-weight:bold;">10元</span>话费红包',
                    //     name: '支付宝新客10元话费红包',
                    //     ruleDesc: '下载支付--扫码--注册领取红包--完成绑卡实名--核销红包（0元充值话费）',
                    //     price: 24,
                    //     settleRule: '',
                    // },
                    // {
                    //     id: 75,
                    //     showName: '美团新用户<span style="font-size:2rem;font-weight:bold;">0.1元</span>购',
                    //     name: '美团新用户0.1元购',
                    //     ruleDesc: '下载-扫码-输入手机号领券-点击现在领好货-登录-下单支付',
                    //     price: 14,
                    // },
                ],
                dialogVisible: false,
                kuaishouZhuboDialogVisible: false,
                jobInfo: {
                    id: null,
                    name: null,
                    linkTpl: '',
                    linkMode: '',
                    jobQrCode: null,
                    jobLink: '',
                    traderId: '',
                    jobExInfo: {
                        bannerUrl: '',
                        logoUrl: '',
                        ruleUrl: '',
                        courseUrl: '',
                        bgColor: '',
                        videoUrl: '',
                        posterUrl: '',
                    },
                    linkAtrr1: '',
                    linkAtrr2: ''
                },
                month4selected: '3',
                month4SelecteMap: {
                    "3": "近三个月",
                    "6": "近半年",
                    "9": "近九个月",
                    "12": "近一年"
                },
                jobActive: null,
                logDetail: {
                    detailMap: {},
                    page: {
                        rows: [],
                        total: 0
                    }
                },
                queryLog: {
                    traderId: this.$route.query.traderId,
                    mid: this.$route.query.mid,
                    limit: 5,
                    page: 1,
                    jobId: null
                },
                statusMap: {
                    0: '待结算',
                    1: '结算中',
                    2: '已结算',
                },
                shareImgSrc: '',
                painting: {
                    width: '565px',
                    height: '800px',
                    background: '#f4f5f7',
                    views: []
                },
                showPoster: false,
            }
        },
        methods: {
            qrCallback(url, id) {
            },
            queryTaskShare(task) {
                mainAPI.getInfoByTraderId(task.id, this.query.traderId, this.query.mid).then((result) => {
                    this.jobInfo = result.data;
                    this.jobInfo.name = task.name;
                    this.jobInfo.ruleDesc = task.ruleDesc;
                    this.dialogVisible = true;
                    if (this.jobInfo.jobQrCode && this.jobInfo.jobExInfo.posterUrl) {
                        this.jobInfo.jobExInfo.posterUrl = this.jobInfo.jobExInfo.posterUrl.replace("jho2o2.oss-cn-beijing.aliyuncs.com", "17youtuiimg.mbao123.com");
                        this.addPoster();
                    }
                })
            },
            handleMonth4Change() {
                this.queryLogDetail();
            },
            jobChange(index, title) {
                this.queryLog.jobId = this.showTaskList[index].id;
                this.queryLogDetail();
            },
            handlePageChange() {
                this.queryLogDetail();
            },
            queryLogDetail() {
                this.$toast.loading({forbidClick: true});
                if (!isNaN(this.month4selected)) {
                    this.queryLog.startSettleDateStr = this.$myUtil.startDateStr(this.month4selected * 30)
                }
                countAPI.logDetailWithoutLogin(this.queryLog).then((result) => {
                    this.logDetail = result.data;
                    this.$toast.clear()
                })
            },
            success(src) {
                this.shareImgSrc = src;
            },
            fail(err) {
                console.log('fail', err)
            },
            addPoster() {
                this.painting.views.push(
                    {
                        type: 'image',
                        url: this.jobInfo.jobExInfo.posterUrl,
                        css: {}
                    }
                );
                this.painting.views.push(
                    {
                        type: 'rect',
                        css: {
                            top: '610px',
                            left: '400px',
                            color: '#fff',
                            width: '110px',
                            height: '110px'
                        }
                    }
                );
                this.painting.views.push({
                    type: 'qrcode',
                    content: this.jobInfo.jobQrCode,
                    css: {
                        top: '612px',
                        left: '402px',
                        color: '#000',
                        width: '106px',
                        height: '106px'
                    }
                });
            },
            initPainting() {
                this.showPoster = false;
                this.painting = {
                    width: '565px',
                    height: '800px',
                    background: '#f4f5f7',
                    views: []
                }
            },
            backforward(){
                window.history.go(-1); // 返回上一步
            }
        },
        created() {
            this.jobChange(0, '');
        },
        mounted() {
            let shareInfo = {
                "imgUrl": "http://jho2o.oss-cn-beijing.aliyuncs.com/test/2Ns9IUQR.png",
                "title": "领福利",
                "desc": "红包优惠券、特价话费流量、免费实物礼品，这是一个只有福利的页面！",
                "link": window.location.href,
            };
            constantAPI.weChatShareConfig(shareInfo.link).then((result) => {
                wxShare.setWxConfig(result.data);
                wxShare.setShare(shareInfo);
            });
            pvuvAPI.addPv("benefit/jjqcl", this.query.traderId).then((result) => {
            });
        }
    }

</script>

<style lang="scss" scoped>

    .task {
        padding: 1rem;
        margin: 1rem 1rem 0rem 1rem;
        border-left: 3px solid #ee9900;
        -moz-box-shadow: 0 0 10px #e5e5e5;
        -webkit-box-shadow: 0 0 10px #e5e5e5;
        box-shadow: 0 0 10px #e5e5e5;

        .van-button {
            background-color: #ee9900;
            color: #fff;
        }
    }

    .title {
        font-size: 1.5rem;
        font-weight: bold;
        margin: 2rem;
    }

    .qrCode {
        margin: 1rem auto;
        width: 15.42rem;
        height: 15.42rem;
        background: white;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .buttom {
        border-top: 4px solid #f2f2f2;
        .van-row {
            margin: 1rem;
            font-size: 1.1rem;
        }

        .table-box {
            height: 16.7rem;
            overflow-x: scroll;
            white-space: nowrap;
            -webkit-overflow-scrolling: touch;
            color: #7d7e80;
            table tr td {
                text-align: center;
                line-height: 1.6rem;
            }
        }

        .van-pagination__item {
            color: #ee9900;
        }

        .noData {
            width: 6.9rem;
            height: 6.9rem;
            margin: 4rem auto 4rem auto;
            text-align: center;
            color: #E6E6E6;
            i {
                font-size: 5rem;
            }
        }

    }

</style>
